import { Component, OnInit,inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { AuthService } from '../../services/auth.service';
import { MatOption, MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { passwordMatchValidator } from '../../../shared/validators/validators';
import { NomAreaDto } from '../../../shared/models/nomenclator-model';
import { NotificationService } from '../../../shared/services/notification.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Router } from '@angular/router';
import { Footer } from '@/app/layout/footer/footer';
import { Navbar } from '@/app/layout/navbar/navbar';
import { Routes } from '@/app/shared/consts/routes';
import { LoginRequest } from '@/app/shared/models/login-request';
import { Nomenclators } from '@/app/shared/services/nomenclators.service';
import {
  TranslateService,
    TranslatePipe,
    TranslateDirective
} from "@ngx-translate/core";
import { NomTitle } from '@/app/shared/models/person-model';
import { MatOptionModule } from '@angular/material/core';
import { CommonModule } from '@angular/common';
import { FeaturesService } from '@/app/features/services/features.service';
import { MatDialog } from '@angular/material/dialog';
import { OtpVerification, OtpDialogData } from '../otp-verification/otp-verification';

@Component({
  selector: 'app-register',
  imports: [ReactiveFormsModule,
    MatOptionModule,
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatSelectModule,
    MatCheckboxModule, Navbar, Footer, TranslatePipe],
  templateUrl: './register.html',
  styleUrl: './register.scss',
})
export class Register implements OnInit {
 private translate = inject(TranslateService);
  form!: FormGroup;

  mostrarPassword = false;
  mostrarConfirm = false;
  acceptEmailUpdate = true;

  listAreas: NomAreaDto[] = [];
  listTitle: NomTitle[] = [];

  public routes: typeof Routes = Routes;

  constructor(private fb: FormBuilder, private authService: AuthService, private nomenclatorService: Nomenclators, private featuresService: FeaturesService, 
    private notificacionService: NotificationService, protected ngxLoaderService: NgxUiLoaderService, protected router: Router, public dialog: MatDialog
  ) { 
  }

  ngOnInit(): void {
    this.getTitles();

    this.form = this.fb.group({
      name: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      phone: new FormControl({ value: null, disabled: false }),
      isUser: [false],
      password: ['', [Validators.required, Validators.minLength(6)]],
      confirm: ['', Validators.required],
      idNumber: ['', Validators.required],
      acceptEmailUpdate: [true],
      profession: ['', Validators.required],
      workplace:  ['', Validators.required],
      nomTitle: [null, Validators.required]
    },
      { validators: passwordMatchValidator });

      
  }


  onSubmit() {
    if (this.form.valid && this.form.value.password === this.form.value.confirm) {
      this.ngxLoaderService.start();

      let register = this.form.value;

      this.authService.registerPerson(register,null)
        .subscribe({
          next: (res) => {
            this.ngxLoaderService.stop();
            this.openOtpVerification(register);
          },
          error: (err) => {
            this.ngxLoaderService.stop();
            this.notificacionService.notificationError(
              this.translate.instant('ERRORS.SORRY_ERROR') + err,
              this.translate.instant('COMMON.ERROR')
            );
          },
        });
    } else {
      this.form.get('confirm')?.setErrors({ mismatch: true });
    }
  }

  openOtpVerification(register: any) {
    const dialogData: OtpDialogData = {
      email: this.form.controls['email'].value,
      mode: 'registration',
      personData: register,
    };

    const dialogRef = this.dialog.open(OtpVerification, {
      width: '420px',
      disableClose: true,
      data: dialogData,
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result?.success) {
        this.login();
      } else {
        this.router.navigate([this.routes.LOGIN]);
      }
    });
  }

  login() {
    const loginRequest: LoginRequest = {
      username: this.form.controls['email'].value,
      password: this.form.controls['password'].value
    };

    this.ngxLoaderService.start();
    this.authService.login(loginRequest).subscribe({
      next: (res) => {
        setTimeout(() => {
          this.ngxLoaderService.stop();
          this.router.navigate([this.routes.INICIO]);
        }, 1000);
      },
      error: (err) => {
        this.ngxLoaderService.stop();
        this.router.navigate([this.routes.HOME]);
      },
    });
  }

  getTitles(): void {
    this.ngxLoaderService.start();
    this.authService.getAllTitle().subscribe({
      next: (res) => {
        this.listTitle = res;
        this.ngxLoaderService.stop();
      },
    error: (err) => {
    console.error('Error en getTitles:', err.message);
    this.ngxLoaderService.stop();
    this.notificacionService.notificationError(
      this.translate.instant('ERRORS.SORRY_ERROR'),
      err.message || this.translate.instant('COMMON.ERROR')
    );
      },
    });
  }
}
